import { render, staticRenderFns } from "./PejuangOnline.vue?vue&type=template&id=7a8bd6a4&"
import script from "./PejuangOnline.vue?vue&type=script&lang=js&"
export * from "./PejuangOnline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports